import React from "react";

export default function WebappHint(props) {

    const x = props.x;
	const renderCount = React.useRef(1);
	const hints = React.useRef({});
	const hintCloseCounter = React.useRef([]);
	const hintIntervalHandle = React.useRef([]);
	const hintId = React.useRef(1);

	// Zeiger auf Funktionen
	x.wah.addHint = addHint;
	x.wah.removeHint = removeHint;
	x.wah.isVisible = isVisible;

	React.useEffect(() => {
		if (renderCount.current === 1) {
			props.childRendered();
		}
		renderCount.current++;
	});

	function addHint(hint, autoClose = true, buttonTitle = '', buttonCallback) {
		const currentId = hintId.current;
		hints.current[currentId] = makeHint(hint, autoClose, buttonTitle, buttonCallback);
		hintId.current++;
		return currentId;
	}

	function removeHint(event, id) {
		if (event !== null) event.preventDefault();
		hints.current[id] = null;
		x.was.removeHint('hint-' + id);
	}
	function makeHint(hint, autoClose = true, buttonTitle = '', buttonCallback) {
		try {
			const currentId = hintId.current;
			const hintText = <div className="hint-text">{hint}</div>;
			let hintClose, hintButton = null;
			hintCloseCounter.current[currentId] = 3;


			if (buttonTitle !== '') {
				hintButton = 
					<span className="hint-button">
						<button 
							type="button" 
							className="btn " 
							onClick={() => { 
												buttonCallback(); 
												removeHint(null, currentId)}
											} 
							title={buttonTitle}
						>
							{buttonTitle}
						</button>
					</span>;

			}

			if (autoClose) {
				hintClose = makeAutoCloseTag(currentId);
				hintIntervalHandle.current[currentId] = setInterval(() => {
					hintCloseCounter.current[currentId]--;
					if (hintCloseCounter.current[currentId] === 0) {
						clearInterval(hintIntervalHandle.current[currentId]);
						removeHint(null, currentId);
					}
					else {
						x.was.removeHint('hint-' + currentId);
						const hintClose = makeAutoCloseTag(currentId);
						const hintTag = <div id={'hint-' + currentId} className="hint">
							{hintClose}
							{hintText}
						</div>;
						x.was.addHint(hintTag);
					}
				}, 1000);
			}
			else {
				hintClose = <span className="hint-close bi bi-x" onClick={e => removeHint(e, currentId)} />;
			}
			console.log(buttonTitle);
			const hintTag = <div id={'hint-' + currentId} className="hint">
				{hintClose}
				{hintText}
				{hintButton}
			</div>;
			x.was.addHint(hintTag);
			return hintId.current;
		}
		catch (err) {
			x.was.reportError(err);
		};
	}

	function makeAutoCloseTag(currentId) {
		return <span>
			<span className={`hint-close bi ${'bi-' + hintCloseCounter.current[currentId] + '-square'} `} onClick={e => removeHint(e, currentId)} />
		</span>;
	}

	function isVisible(hintId) {
		if (typeof hints.current[hintId] != 'undefined' && hints.current[hintId] !== null) {
			return true;
		}
		else {
			return false;
		}
	}

	return (
		<React.Fragment />
	);

}

